import {ExtendedShiftQuickSelectSlots} from '@hconnect/common/types'
import {Moment} from 'moment-timezone'

function getTodayTiming(now: Moment): [start: Moment, end: Moment] {
  const today = now.clone().startOf('day')
  return [today, now.startOf('minute')]
}

function getYesterdayTiming(now: Moment): [start: Moment, end: Moment] {
  const yesterdayStart = now.clone().add(-1, 'day').startOf('day')
  const yesterdayEnd = now.clone().add(-1, 'day').endOf('day')
  return [yesterdayStart, yesterdayEnd]
}

function getLast7days(now: Moment): [start: Moment, end: Moment] {
  return [now.clone().subtract(7, 'day'), now]
}

function getCurrentMonthTiming(now: Moment): [start: Moment, end: Moment] {
  const currentMonthStart = now.clone().startOf('month')
  const currentMonthEnd = now.clone().endOf('month')
  return [currentMonthStart, currentMonthEnd]
}

function getLastMonthTiming(now: Moment): [start: Moment, end: Moment] {
  const lastMonthStart = now.clone().subtract(1, 'month').startOf('month')
  const lastMonthEnd = now.clone().subtract(1, 'month').endOf('month')
  return [lastMonthStart, lastMonthEnd]
}

const slotFunctionsMap = {
  today: getTodayTiming,
  yesterday: getYesterdayTiming,
  last7days: getLast7days,
  lastMonth: getLastMonthTiming,
  currentMonth: getCurrentMonthTiming
}

export function getPlantEntryPointQuickSelectFilter(
  slot: ExtendedShiftQuickSelectSlots,
  now: Moment
): [start: Moment, end: Moment] {
  if (!slotFunctionsMap[slot]) {
    throw new Error(`Unknown predefined time slot: ${slot}`)
  }

  return slotFunctionsMap[slot](now)
}
